import React, { useState } from 'react';
import Card from './Card';
import Navbar from './Navbar';
import './home.css'
import AddButton from './AddButton';
import BlogModal from './BlogModal';
import EditBlogModal from './EditBlogModal';
import Alert from '../Alert/Alert';
import Footer from '../Footer/Footer';

function Home(props) {

  const [state, setState] = useState(false);
  const [editId, setEditId] = useState('');

  document.title = 'TBC Experts | Academy';

  
  return (
    <>
      <div className="homeBg bg-black">
        <Navbar handleLogout={props.handleLogout} />
        <Alert mT='85px' mR='40px' />
        <Card state={state} setEditId={setEditId} email={props.email} />
        <AddButton />
        <BlogModal email={props.email} state={setState} />
        <EditBlogModal editId={editId} />
      </div>
      <Footer />
    </>

  );
}

export default Home;
